import { AppRouter } from './app/router/AppRouter';
import './App.css';
import './styles/globals.css';

export default function App() {
  return (
    <>
      <div id="google_translate_element" className="google-translate-hidden" />
      <AppRouter />
    </>
  );
}
